export default "__VITE_ASSET__297674c0__"